module.exports = __webpack_public_path__ + "img/sort_normal.839d2653.svg";